import { useRouteMatch } from 'react-router';
import { SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import NavBack from 'dashboard/components/NavBack';
import { removeLastPath } from 'lib/utils/url';

const StyledNavBack = styled(NavBack)`
  margin-top: ${SPACINGS.base * 4}px;
  margin-left: ${SPACINGS.base * 2}px;
`;

interface ThemeEditorNavBackProps {
  /**
   * Used within the context of a <Routes> react-router v6 component to navigate back to the root
   */
  reactRouterV6?: boolean;
}

const ThemeEditorNavBack = (props: ThemeEditorNavBackProps) => {
  const { url: matchUrl } = useRouteMatch();
  const rootUrl = removeLastPath(matchUrl);

  return (
    <StyledNavBack data-test='theme-editor-nav-back' to={props.reactRouterV6 ? '../' : rootUrl}>
      Back
    </StyledNavBack>
  );
};

export default ThemeEditorNavBack;
